import { z } from 'zod';
import { SAddress } from './address';
import { SEmergencyContactResponse } from './emergency-contact';
import { SIndividualResponse } from './individual';
import { SUserResponse } from './user';

export const SUserAndAddressResponse = z.object({
  user: SUserResponse,
  individual: SIndividualResponse,
  address: z.array(SAddress).nullable(),
  emergency_contact: z.array(SEmergencyContactResponse).nullable(),
});
export type TUserAndAddressResponse = z.infer<typeof SUserAndAddressResponse>;

export const SAddressInputResponse = z.object({
  status: z.number(),
  message: z.string(),
});
export type TAddressInputResponse = z.infer<typeof SAddressInputResponse>;

export const SSimpleResponse = z.string();
export type TSimpleResponse = z.infer<typeof SSimpleResponse>;

export const SUploadKtpResponse = z.object({
  fullname: z.string().nullable(),
  province: z.string().nullable(),
  city: z.string().nullable(),
  identity_number: z.string().nullable(),
  birth_place: z.string().nullable(),
  birth_date: z.coerce.date().nullable(),
  nationality: z.string().nullable(),
  occupation: z.string().nullable(),
  gender: z.string().nullable(),
  marital_status: z.string().nullable(),
  blood_type: z.string().nullable(),
  address: z.string().nullable(),
  rt_rw: z.string().nullable(),
  kel_desa: z.string().nullable(),
  kecamatan: z.string().nullable(),
  religion: z.string().nullable(),
  expired_date: z.string().nullable(),
  state: z.string().nullable(),
});
export type TUploadKtpResponse = z.infer<typeof SUploadKtpResponse>;

export const SUploadKtpImageToTextResponse = z.object({
  fullname: z.string().nullable(),
  province: z.string().nullable(),
  city: z.string().nullable(),
  identity_number: z.string().nullable(),
  birth_place: z.string().nullable(),
  birth_date: z.coerce.date().nullable(),
  nationality: z.string().nullable(),
  occupation: z.string().nullable(),
  gender: z.string().nullable(),
  marital_status: z.string().nullable(),
  blood_type: z.string().nullable(),
  address: z.string().nullable(),
  rt_rw: z.string().nullable(),
  kel_desa: z.string().nullable(),
  kecamatan: z.string().nullable(),
  religion: z.string().nullable(),
  expired_date: z.string().nullable(),
  state: z.string().nullable(),
});
export type TUploadKtpImageToTextResponse = z.infer<
  typeof SUploadKtpImageToTextResponse
>;

export const SReviewInputResponse = z.object({
  success: z.boolean(),
  message: z.string(),
  data: z.array(
    z.object({
      id: z.number(),
      item_id: z.string(),
      item_type: z.number(),
      star_rating: z.number(),
      title: z.string(),
      review_text: z.string(),
    })
  ),
});

export type TReviewInputResponse = z.infer<typeof SReviewInputResponse>;
